import parse, { domToReact } from 'html-react-parser'
import DOMPurify from 'dompurify'
import React from 'react'

export function html(html, opts = {}) {
  return parse(DOMPurify.sanitize(html), {
    ...{
      replace: html,
    },
    ...opts,
  })
}

export function sortGroupStrings(a,b) {
  try {
    let aNew = parseInt('000' + a.replace('group-', ''));
    let bNew = parseInt('000' + b.replace('group-', ''));
    return aNew - bNew;
  } catch (error) {
    return a > b;
  }
}

export function striphtml(the_str) {
  console.log('the str', the_str);
  return the_str.replace(/<\/?[^>]+(>|$)/g, "");
}

export const hasGameControl = (leaderID, userID, profile) => {
  if (leaderID === userID || profile.role === 'host' || profile.role === 'moderator' ) {
    return true;
  } else {
    return false;
  }
};

export function getUserGroup(session, uid) {
  let group_id = null;

  Object.keys(session.groups).map((group, index) => {
    if (session.groups[group].playerIds.includes(uid)) {
      return (group_id = session.groups[group].id);
    } else {
      return null;
    }
  });

  return group_id;
}

export function getUserGroup_hc(session, uid, role) {
  let group_id = null;

  if (role === 'host') {
    group_id = session.hostState.params.group ? session.hostState.params.group : null;
  } else if ( role === 'moderator' ){
    group_id = session.moderatorStates[uid].params.group ? session.moderatorStates[uid].params.group : null;
  } else {
    
      Object.keys(session.groups).map((group, index) => {
        if (session.groups[group].playerIds.includes(uid)) {
          return (group_id = session.groups[group].id);
        } else {
          return null;
        }
      });
    
  }
  return group_id;
}

export function determineHost(profile, auth){
  switch ( profile.role ){
    case 'host':
      return auth.uid;
    case 'moderator':
      return profile.moderates;
    case 'player':
      return profile.sessionHost;
    case 'admin':
      return auth.uid;
    default:
      return profile.sessionHost;
  }
}

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
export var deepDiffMapper = function () {
    return {
      VALUE_CREATED: 'created',
      VALUE_UPDATED: 'updated',
      VALUE_DELETED: 'deleted',
      VALUE_UNCHANGED: 'unchanged',
      map: function(obj1, obj2) {
        if (this.isFunction(obj1) || this.isFunction(obj2)) {
          throw 'Invalid argument. Function given, object expected.';
        }
        if (this.isValue(obj1) || this.isValue(obj2)) {
          return {
            type: this.compareValues(obj1, obj2),
            data: obj2 === undefined ? obj1 : obj2
          };
        }
  
        var diff = {};
        for (var key in obj1) {
          if (this.isFunction(obj1[key])) {
            continue;
          }
  
          var value2 = undefined;
          if (obj2[key] !== undefined) {
            value2 = obj2[key];
          }
  
          diff[key] = this.map(obj1[key], value2);
        }
        for (var key in obj2) {
          if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
            continue;
          }
  
          diff[key] = this.map(undefined, obj2[key]);
        }
  
        return diff;
  
      },
      compareValues: function (value1, value2) {
        if (value1 === value2) {
          return this.VALUE_UNCHANGED;
        }
        if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
          return this.VALUE_UNCHANGED;
        }
        if (value1 === undefined) {
          return this.VALUE_CREATED;
        }
        if (value2 === undefined) {
          return this.VALUE_DELETED;
        }
        return this.VALUE_UPDATED;
      },
      isFunction: function (x) {
        return Object.prototype.toString.call(x) === '[object Function]';
      },
      isArray: function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
      },
      isDate: function (x) {
        return Object.prototype.toString.call(x) === '[object Date]';
      },
      isObject: function (x) {
        return Object.prototype.toString.call(x) === '[object Object]';
      },
      isValue: function (x) {
        return !this.isObject(x) && !this.isArray(x);
      }
    }
  }();